import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// services
import * as accountService from '../../../services/accountService'
// styles
import styles from "./AccountsAdmin.module.css"
// components
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import ExhibitorItem from '../../../components/Account/AccountsAdmin/ExhibitorItem'
// ------ Font Awesome assets ------ //
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareCaretUp, faSquareCaretDown } from '@fortawesome/free-solid-svg-icons'
// ------ Image Elements ------ //
const up = <FontAwesomeIcon icon={faSquareCaretUp} style={{ color: 'blue', width: '20px', height: '20px' }} />
const down = <FontAwesomeIcon icon={faSquareCaretDown} style={{ color: 'blue', width: '20px', height: '20px' }} />
const AccountsAdmin = ({ user}) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [isCleared, setIsCleared] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [admins, setAdmins] = useState([])
    const [combinedFilteredAdmins, setCombinedFilteredAdmins] = useState([])
    const [filter, setFilter] = useState(null)
    const [sorting, setSorting] = useState({ key: "lastName", ascending: true });

    function applySorting(key) {
        if (sorting.key === key) {
            setSorting({ ...sorting, ascending: !sorting.ascending });
        } else {
            setSorting({ key: key, ascending: true });
        }
    }
    // ------ Name Search ------ //
    const NameFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        admins.forEach((admin) => {
            const nameFirst = admin.firstName.toLowerCase()
            const nameLast = admin.lastName.toLowerCase()
            if (!filterString || nameFirst.includes(filterString) || nameLast.includes(filterString) ) {
                filtered.push(admin)
            }
        })
        return filtered
    }

    const filteredByName = admins && admins.length ? NameFilter(filter) : []

    // ------ UserName Search ------ //
    const UserNameFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        admins.forEach((admin) => {
            const nameEmail = admin.userName ? admin.userName.toLowerCase() : ''
            if (!filterString || nameEmail.toString().includes(filterString)) {
                filtered.push(admin)
            }
        })
        return filtered
    }

    const filteredByUserName = admins && admins.length ? UserNameFilter(filter) : []

    // ------ Organization Search ------ //
    const OrganizationFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        admins.forEach((admin) => {
            const organization = admin.organization ? admin.organization.toLowerCase() : ''
            if (!filterString || organization.includes(filterString)) {
                filtered.push(admin)
            }
        })
        return filtered
    }

    const filteredByOrganization = admins && admins.length ? OrganizationFilter(filter) : []

    // ------ Role Search ------ //
    const RoleFilter = filterString => {
        if (filterString && filterString.toLowerCase) {
            filterString = filterString.toLowerCase()
        }
        let filtered = []
        admins.forEach((admin) => {
            const email = admin.roleName ? admin.roleName.toLowerCase() : ''
            if (!filterString || email.includes(filterString)) {
                filtered.push(admin)
            }
        })
        return filtered
    }

    const filteredByRole = admins && admins.length ? RoleFilter(filter) : []

    // ------ Helper Functions ------ //
    const clearFilters = () => {
        setIsCleared(true)
        setFilter('')
        setIsCleared(false)
    }
    function applySorting(key) {
        if (sorting.key === key) {
            setSorting({ ...sorting, ascending: !sorting.ascending });
        } else {
            setSorting({ key: key, ascending: true });
        }
    }

    // ------ useEffect ------ //
    useEffect(() => {
        if (admins && admins.length > 0) {
            let leds = [...admins];
            let filteredResults = []
            // apply filtering
            leds.forEach((led) => {
                if (filteredByName.includes(led)) {
                    if (filteredByUserName.includes(led)) {
                        if (filteredByOrganization.includes(led)) {
                            if (filteredByRole.includes(led)) {
                                filteredResults.push(led)
                            }
                        }
                    }
                }
            })
            // apply sorting
            let sortedResults = filteredResults.sort((a, b) => {
                const optionA = a[sorting.key] && a[sorting.key] !== undefined ? a[sorting.key].toString().toLowerCase() : ''

                const optionB = b[sorting.key] && b[sorting.key] !== undefined ? b[sorting.key].toString().toLowerCase() : ''

                if (optionA < optionB) {
                    return sorting.ascending ? -1 : 1;
                }
                if (optionA > optionB) {
                    return sorting.ascending ? 1 : -1;
                }
                return 0;
            })
            setCombinedFilteredAdmins(sortedResults);
        }

    }, [admins, filter, sorting])
    
    const handleChange = e => {
        setFilter(e.target.value);
    }
   
    const fetchAdmins = async () => {
        let adminsList = await accountService.getExhibitors();
        if (adminsList && adminsList.length > 0) {
            setAdmins(adminsList);
        }
        setLoaded(true);
    };

    useEffect(() => {
        fetchAdmins();
    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Exhibitor Admins</h1><br />
            <p>
                <strong>Name:</strong> Exhibitor Account first and last name. <br />
                <strong>UserId:</strong> Login email. <br />
                <strong>Role:</strong> Security Level: <br />
                <ul>Exhibitor accounts are secondary accounts that have fewer/limited abilites:</ul>
                <li className={styles.liAdminAccounts}> Exhibitor can see events specified for account.<strong>Note: Lowest level of permissions.</strong></li>
                <li className={styles.liAdminAccounts}> Admin can see events specified for account, and register exhibitors.</li>
                <li className={styles.liAdminAccounts}> Superadmin can do everything.</li>
                <strong>Parent Acct:</strong>  Admin account associated with this account. <strong>Note: Applies to exhibitor accounts only.</strong><br/>
                <strong>Activate/Deactivate:</strong> Activate or deactivate accounts.<br />
                <strong>Resend Verification Email:</strong> Only for unconfirmed accounts. Sends code to user to confirm their email account, finishing the registration process.<br />
            </p><br /><br />
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <label> <strong>Keyword:</strong> </label>
                            <input
                                type='filter'
                                value={filter}
                                onChange={handleChange} // option selected
                                name='filter'
                                placeholder='Enter Search...'
                            />{filter ?
                                <button onClick={clearFilters} id={styles.clearFilters}>
                                    Clear Filter
                                </button>
                                :
                                <>
                                </>
                            } <br /><br />
                            <label> <strong>* Note: keyword is applied to: User Name, First Name, Last Name, and Organization</strong> </label>
                            <br /><br />

                            <h3>Total Admins: {admins.length}</h3>
                            <br />
                            <br />
                            {
                                combinedFilteredAdmins && combinedFilteredAdmins.length > 0 ?
                                    <>
                                        <table className={styles.tableAdmins}>
                                            <thead>
                                                <tr className={styles.trAdmins}>
                                                    <th className={styles.thAdmins} onClick={() => applySorting('lastName')}>
                                                        Name (UserName){sorting.key === 'lastName' && sorting.ascending ? up : down}
                                                        <HoverButton
                                                            title={'Admin name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins} onClick={() => applySorting('role')}>
                                                        Role {sorting.key === 'role' && sorting.ascending ? up : down}
                                                        <HoverButton
                                                            title={'Admin role'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins} onClick={() => applySorting('leadCaptureName')}>
                                                        Lead Capture Events {sorting.key === 'leadCaptureName' && sorting.ascending ? up : down}
                                                        <HoverButton
                                                            title={'Admin lead capture name'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins} onClick={() => applySorting('accounts')}>
                                                        Exhibitor Accounts {sorting.key === 'accounts' && sorting.ascending ? up : down}
                                                        <HoverButton
                                                            title={'Admin accounts'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins}>
                                                        Parent Account
                                                        <HoverButton
                                                            title={'Admin parent account'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins} onClick={() => applySorting('isDeleted')}>
                                                        Activate/Deactivate {sorting.key === 'isDeleted' && sorting.ascending ? up : down}
                                                        <HoverButton
                                                            title={'Admin active or not'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins}>
                                                        Invite
                                                        <HoverButton
                                                            title={'Resend site invite'}
                                                            messageWidth={75}
                                                        />
                                                    </th>
                                                    <th className={styles.thAdmins}>
                                                        
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody key={combinedFilteredAdmins.length}>
                                                {combinedFilteredAdmins.map((item, index) => (
                                                    <ExhibitorItem
                                                        index={index}
                                                        exhibitor={item}
                                                        user={user}
                                                    >
                                                    </ExhibitorItem>
                                                ))}
                                            </tbody>

                                        </table></>

                                    : <>
                                        <div>
                                            {admins && admins.length > 0 ?
                                                <div className={styles.errorAdminsMessage}> No admins match filter.</div>
                                                :
                                                <div className={styles.errorAdminsMessage}> No admins found!</div>
                                            }
                                        </div>
                                    </>

                            }

                        </>
                }
            </>
            <br />
            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default AccountsAdmin;